import { render, staticRenderFns } from "./NotebookDetailsHeader.vue?vue&type=template&id=2e58900a&"
import script from "./NotebookDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./NotebookDetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./NotebookDetailsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports